import register from '../../../../global/js/registry';
export default register('m-product-gallery-details', () => import(/* webpackMode: "lazy" */ './m-product-gallery-details.controller'));
